import { OnChangeFn, RowSelectionState } from "@tanstack/react-table";
import { useInstantSearch } from "react-instantsearch";
import { CustomPagination } from "views/renters/components/CustomPagination";
import { RentersTable } from "views/renters/components/Table/RentersTable";

type Props = {
  setSelectedRentersRow: OnChangeFn<RowSelectionState>;
  selectedRentersRow: RowSelectionState;
};

// This wrapper needs to prevent loop rerenders for table with results from useInstantSearch
export const RentersTableWrapper = ({
  setSelectedRentersRow,
  selectedRentersRow
}: Props) => {
  const { results } = useInstantSearch();

  return (
    <div className="mt-4">
      <RentersTable
        results={results}
        setSelectedRentersRow={setSelectedRentersRow}
        selectedRentersRow={selectedRentersRow}
      />

      <div className="ml-auto mt-4 flex w-full max-w-[575px] justify-end">
        <CustomPagination />
      </div>
    </div>
  );
};
